import React from "react";
import GroupTiles from "./GroupTiles";
import SectionHeading from "./SectionHeading";
import {useDebugMode} from "../hooks/useDebugMode";

const log = (...a) =>
  console.debug(
    "%c[PersonalisedCategories]",
    "color:#14b8a6;font-weight:bold",
    ...a
  );

const PersonalisedCategories = ({
  contextId,
  fetchRecommendationsForContext,
  data, // ← personalisedData["38"] arrives here
  isLoading,
  viewInterceptor,
  devModeEnabled = false,
}) => {
  log("render", {contextId, items: data?.length});
  const debugMode = useDebugMode();

  return (
    <section className="container py-8">
      <SectionHeading
        kicker="Section fronts"
        title="Categories"
        standfirst="Both the sections and the stories inside them are ordered for you."
        debugNote={`ctx ${contextId} · grouped results · group order and item order both personalised`}
        debugMode={debugMode}
      />

      <GroupTiles
        contextId={contextId}
        fetchRecommendationsForContext={fetchRecommendationsForContext}
        /* CRITICAL – pass the array down */
        recommendations={data}
        isLoading={isLoading}
        viewInterceptor={viewInterceptor}
        devModeEnabled={devModeEnabled}
      />
    </section>
  );
};

export default PersonalisedCategories;
